import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  CardActions,
  Skeleton
} from "@mui/material";
import { ChecklistRtl } from "@mui/icons-material";

const TemplateChecklistCardSkeleton = () => (
  <Card 
    sx={{ 
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      transition: 'all 0.2s ease-in-out'
    }}
  >
    <CardContent sx={{ flexGrow: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
        <Skeleton variant="text" width="70%" height={32} sx={{ flexGrow: 1 }} />
        <Skeleton variant="rectangular" width={90} height={24} sx={{ ml: 1, borderRadius: 12 }} />
      </Box>
      
      <Skeleton variant="text" width="50%" height={20} sx={{ mb: 2 }} />
      <Skeleton variant="text" width="100%" height={16} />
      <Skeleton variant="text" width="80%" height={16} />
    </CardContent>

    <CardActions sx={{ p: 2, pt: 0 }}>
      <Skeleton variant="rectangular" width="100%" height={36} sx={{ borderRadius: 1 }} />
    </CardActions>
  </Card>
);

export default function TemplateChecklistSkeleton() {
  return (
    <Container maxWidth={false}>
      <Box sx={{ py: 3 }}>
        {/* Header com título e ícone */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <ChecklistRtl sx={{ fontSize: 32, mr: 2, color: 'primary.main' }} />
          <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: 'text.primary' }}>
            Gestão de Templates de Checklist
          </Typography>
        </Box>

        {/* Descrição */}
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Gerencie templates de checklist por concessionária. Cada template será usado como base 
          para criar checklists em novos projetos.
        </Typography>

        {/* Grid de skeletons simulando cards das concessionárias */}
        <Grid container spacing={3}>
          {Array.from({ length: 6 }).map((_, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <TemplateChecklistCardSkeleton />
            </Grid>
          ))}
        </Grid>

        {/* Indicador de carregamento */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Skeleton variant="circular" width={20} height={20} />
            <Typography variant="body2" color="text.secondary">
              Carregando dados das concessionárias...
            </Typography>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
